// utils/getOrCreateUserId.ts
export function getOrCreateUserId(){
  const key = 'userId';
  let userId = localStorage.getItem(key);

  if (!userId) {
    userId = `user_${Math.random().toString(36).substring(2, 10)}`;
    localStorage.setItem(key, userId);
  }

  return userId;
}
